import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentPage: 0,
    scrollLeftTrigger: 0,
 
    brands: null,
    brandArrayIndex: 0,
    brandNavigationShowing: false,
    brandMobileP2Showing: false,

    types: null,
    typeArrayIndex: 0,
    typeNavigationShowing: false,
    typeMobileP2Showing: false,

    libraryIndexes: null,
    selectedLibraryIndex: 0
  },
  mutations: {
    setCurrentPage(state, src) {
      state.currentPage = src
    },
    setBrands(state, src) {
      state.brands = src
    },
    setBrandArrayIndex(state, src) {
      state.brandArrayIndex = src
    },
    setBrandNavigationShowing(state, src) {
      state.brandNavigationShowing = src
    },
    setBrandMobileP2Showing(state, src) {
      state.brandMobileP2Showing = src
    },
    setTypes(state, src) {
      state.types = src
    },
    setTypeArrayIndex(state, src) {
      state.typeArrayIndex = src
    },
    setTypeNavigationShowing(state, src) {
      state.typeNavigationShowing = src
    },
    setTypeMobileP2Showing(state, src) {
      state.typeMobileP2Showing = src
    },
    updateScrollLeftTrigger(state) {
      state.scrollLeftTrigger ++
    },
    setLibraryIndexes(state, src) {
      state.libraryIndexes = src
    },
    setSelectedLibraryIndex(state, src) {
      state.selectedLibraryIndex = src
    }
  },
  actions: {
    doSetPage({commit}, src) {
      console.log('page:' + src)
      commit('setCurrentPage', src)
    },
    doSetBrands({commit}, src) {
      commit('setBrands', src)
    },
    doSetBrandArrayIndex({commit}, src) {
      commit('setBrandArrayIndex', src)
    },
    doSetBrandNavigationShowing({commit}, src) {
      commit('setBrandNavigationShowing', src)
    },
    doSetBrandMobileP2Showing({commit}, src) {
      commit('setBrandMobileP2Showing', src)
    },
    syncBrands({commit, state}, axios) {
      if (!state.brands) {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/brand?order=asc&per_page=100')
        .then(brands => {
          console.log(brands)
          commit('setBrands', brands.data)
          return new Promise(resolve => resolve())
        })
        .catch((e) => {
          alert(e);
          return new Promise(resolve => resolve())
        });
      }
    },
    doSetTypes({commit}, src) {
      commit('setTypes', src)
    },
    doSetTypeArrayIndex({commit}, src) {
      commit('setTypeArrayIndex', src)
    },
    doSetTypeNavigationShowing({commit}, src) {
      commit('setTypeNavigationShowing', src)
    },
    doSetTypeMobileP2Showing({commit}, src) {
      commit('setTypeMobileP2Showing', src)
    },
    syncTypes({commit, state}, axios) {
      if (!state.types) {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/type_note?per_page=100')
        .then(types => {
          console.log(types.data)
          commit('setTypes', types.data)
          return new Promise(resolve => resolve())
        })
        .catch((e) => {
          alert(e);
          return new Promise(resolve => resolve())
        });
      }
    },
    doUpdateScrollLeftTrigger({commit}) {
      commit('updateScrollLeftTrigger')
    },
    doSetLibraryIndexes({commit}, src) {
      commit('setLibraryIndexes', src)
    },
    doSetSelectedLibraryIndex({commit}, src) {
      commit('setSelectedLibraryIndex', src)
    }
  },
  modules: {
  }
})
